var watchlist = {
	createWatchlistAction: "Seleccionar lista de seguimiento",
	editWatchlistAction: "Editar lista de seguimiento",
	deleteWatchlistAction: "Eliminar lista de seguimiento",
	addPosition: "Agregar posición",
	deletePosition: "Eliminar position",
	noWatchlistTitle: "Info.",
	noWatchlistMessage: "Aún no se ha creado ninguna lista de seguimiento. Haga clic en el botón Agregar Lista de Seguimiento y complete el formulario para crear una lista de seguimiento",
	showActions: "Mostrar acciones"
};
var es = {
	watchlist: watchlist
};

export { es as default, watchlist };
